import type { ProjectMapCohort } from '@/services/realtimeClient';

export const COHORT_PRESENTATION: Record<ProjectMapCohort, { label: string; color: string }> = {
  completed: { label: 'Completed', color: '#94a3b8' },
  active: { label: 'Active jobs', color: '#34b399' },
  submitted_bid: { label: 'Submitted bids', color: '#d4a658' },
  awarded_pending: { label: 'Awarded, not started', color: '#6badd4' },
  pursuit: { label: 'Opportunities', color: '#a5b4fc' },
  estimating: { label: 'Estimating', color: '#e0c182' },
  lost_bid: { label: 'Lost bids', color: '#e18b91' },
  no_bid: { label: 'No bid / withdrawn', color: '#a393aa' },
  on_hold: { label: 'On hold', color: '#eea968' },
  cancelled: { label: 'Cancelled', color: '#7f899a' },
  planning: { label: 'Planning', color: '#7cbfc5' },
};
